import { render, staticRenderFns } from "./SelectMunicipio.vue?vue&type=template&id=e62f0052"
import script from "./SelectMunicipio.vue?vue&type=script&lang=js"
export * from "./SelectMunicipio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports